<template>
    <div class="question">
        <h2>Wat betaal je momenteel voor stroom?</h2>
        <span class="description">Ook dit vind je op het overzicht van je energieleverancier.</span>
        <div class="question__inner">
            <div class="option">
                <label>Kale stroomprijs piek/normaal per kWh</label>
                <number-input type="dayPrice" setter="setDayPrice"></number-input>
            </div>
            <div class="option">
                <label>Kale stroomprijs dal per kWh</label>
                <number-input type="nightPrice" setter="setNightPrice"></number-input>
            </div>
        </div>
    </div>
</template>

<script>
import NumberInput from './helpers/number-input'

export default {
  name: 'Q4',
  components: {
    'number-input': NumberInput
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Q4.vue